import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Paper, Snackbar, Stack, TextField } from "@mui/material";
import { TableBody, TableContainer, TableHead } from "@mui/material";
import { TableCell, TableRow } from "@mui/material";
import {
    CustomSelect,
    CustomTextField,
    CustomThemeProvider,
} from "../../../Styles/theme/customThemeprovider";
import BasicPopover from "../../../Components/Popover";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import {
    StyledTableCell,
    StyledTableHead,
} from "../../../Styles/tabelCellStyled/customTableCell";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { Alert } from "../../../Components/Alert/Alert";
import { IFoliar } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { ICabecalho } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { analise_foliar_1_3_classificacao } from "../../../informacao_estatica";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";

interface AnaliseFoliar_prop {
    obj_anexo_cabecalho_selecionado: ICabecalho | undefined;
}


export const AnaliseFoliar: React.FC<AnaliseFoliar_prop> = ({ obj_anexo_cabecalho_selecionado }) => {

    const auth = useContext(AuthContext);
    const location = useLocation();
    const is_historico = location.state?.is_historico ?? false;



    const [createTable, setCreateTable] = useState(false);
    const [message, setMessage] = useState("");
    const [openSnackSuccess, setOpenSnackSuccess] = useState(false);
    const [openSnackError, setOpenSnackError] = useState(false);
    const [obj_anexo, set_obj_anexo] = useState<IFoliar>();
    const [error_resultado_camp1, set_error_resultado_camp1] = React.useState(false);
    const [error_resultado_camp2, set_error_resultado_camp2] = React.useState(false);
    const [error_resultado_camp3, set_error_resultado_camp3] = React.useState(false);
    const [error_resultado_camp4, set_error_resultado_camp4] = React.useState(false);
    const [error_resultado_camp5, set_error_resultado_camp5] = React.useState(false);
    const [error_resultado_camp6, set_error_resultado_camp6] = React.useState(false);
    const [error_resultado_camp7, set_error_resultado_camp7] = React.useState(false);
    const [error_resultado_camp8, set_error_resultado_camp8] = React.useState(false);
    const [error_resultado_camp9, set_error_resultado_camp9] = React.useState(false);
    const [error_resultado_camp10, set_error_resultado_camp10] = React.useState(false);
    const [error_resultado_camp11, set_error_resultado_camp11] = React.useState(false);
    const [error_data_resultados, set_error_data_resultados] = useState(false)
    const [error_data_colheita, set_error_data_colheita] = useState(false)
    const [error_n_amostras, set_error_n_amostras] = useState(false)

    const [obj_anexo_lista, set_obj_anexo_lista] = useState<IFoliar[]>([]);
    const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);


    const handle_update_anexo = async () => {
        if (!obj_anexo?.data_colheita || obj_anexo?.data_colheita === "" || !obj_anexo?.data_resultados || obj_anexo?.data_resultados === "" || error_resultado_camp1 || error_resultado_camp2 || error_resultado_camp3 || error_resultado_camp4 || error_resultado_camp5 || error_resultado_camp6 || error_resultado_camp7 || error_resultado_camp8 || error_resultado_camp9 || error_resultado_camp10 || error_resultado_camp11 || error_n_amostras) {

            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {
            try {
                setIsLoading(true);

                let res = await post(auth.token.cookie_token, "update_reg_anexo_um_tres", { payload: obj_anexo });

                if (res.status === 200) {
                    let lista_aux: any = obj_anexo_lista.map((el) => {
                        if (el.id_anexo_um_tres !== obj_anexo?.id_anexo_um_tres) {
                            return el
                        } else {
                            return res.data.result
                        }
                    })
                    set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                    set_obj_anexo(undefined);
                    set_flag_editado(false)

                    setMessage("Gravado com sucesso!");
                    setOpenSnackSuccess(true);
                } else {
                    setMessage("Erro ao gravar!");

                    setOpenSnackError(true);
                }

                setIsLoading(false);
            } catch (error) {
                func_print("handle_update_anexo", error, true);
                setMessage("Erro ao gravar!");

                setOpenSnackError(true);
                setIsLoading(false);
            }
        }
    };
    const handleCloseDialog = () => {
        set_obj_anexo(undefined)

        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };
    // onChange criar
    const onInputChange = (event: any) => {
        const { name, value, type, checked } = event.target;
        set_flag_editado(true)

        if (type === "checkbox") {
            set_obj_anexo((prev: any) => {
                return {
                    ...prev,
                    [name]: checked,
                };
            });
        } else {
            if (name === "data_colheita") {
                if (value.trim() === "" || value === undefined) {
                    set_error_data_colheita(true);
                } else {
                    set_error_data_colheita(false);
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: value,
                }));
            } else if (name === "data_resultados") {
                if (value.trim() === "" || value === undefined) {
                    set_error_data_resultados(true);
                } else {
                    set_error_data_resultados(false);
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: value,
                }));
            } else if (name === 'n_amostras') {
                if (!/^\d+$/.test(value)) {
                    set_error_n_amostras(true)
                } else {
                    set_error_n_amostras(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: value,
                }));
            } else if (name === 'resultado_camp1') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_resultado_camp1(true)
                } else {
                    set_error_resultado_camp1(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'resultado_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_resultado_camp2(true)
                } else {
                    set_error_resultado_camp2(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'resultado_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_resultado_camp3(true)
                } else {
                    set_error_resultado_camp3(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'resultado_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_resultado_camp4(true)
                } else {
                    set_error_resultado_camp4(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'resultado_camp5') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_resultado_camp5(true)
                } else {
                    set_error_resultado_camp5(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'resultado_camp6') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_resultado_camp6(true)
                } else {
                    set_error_resultado_camp6(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'resultado_camp7') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_resultado_camp7(true)
                } else {
                    set_error_resultado_camp7(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'resultado_camp8') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_resultado_camp8(true)
                } else {
                    set_error_resultado_camp8(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'resultado_camp9') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_resultado_camp9(true)
                } else {
                    set_error_resultado_camp9(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'resultado_camp10') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_resultado_camp10(true)
                } else {
                    set_error_resultado_camp10(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'resultado_camp11') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_resultado_camp11(true)
                } else {
                    set_error_resultado_camp11(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else {
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: value,
                }));

            }


        };

    };

    const handle_delete_anexo = async () => {
        try {
            setIsLoading(true);

            let res = await del(auth.token.cookie_token,
                `delete__reg_anexo_um_tres/${obj_anexo?.id_anexo_um_tres}`
            );
            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista.filter((el) => {
                    if (el.id_anexo_um_tres !== obj_anexo?.id_anexo_um_tres) {
                        return el
                    }
                })
                set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo(undefined)
                setMessage("Registo eliminado com sucesso!");
                set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
                setOpenSnackSuccess(true);
                setCreateTable(true)
            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_anexo", error, true);
            setIsLoading(false);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
        }
    };


    const handleCloseSnack = () => {
        setOpenSnackSuccess(false);
        setOpenSnackError(false);
    };
    const get_info = async () => {
        try {
            let res = await get(auth.token.cookie_token,
                `/get_reg_anexo_um_tres_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
            );
            if (res.status === 200) {
                if (res.data.result.length !== 0) {
                    set_obj_anexo_lista(res.data.result);
                } else {
                    setCreateTable(true)
                }
            } else {
                setMessage("Erro a carregar informação!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("get_info", error, true);
            setMessage("Erro!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };
    useEffect(() => {
        (async () => {
            if (obj_anexo_cabecalho_selecionado !== undefined) {

                await get_info();

            } else {
                setCreateTable(false)
                set_obj_anexo_lista([])

            }
        })();
    }, [obj_anexo_cabecalho_selecionado]);

    const handle_criar_anexo = async () => {
        if (!obj_anexo?.data_colheita || obj_anexo?.data_colheita === "" || !obj_anexo?.data_resultados || obj_anexo?.data_resultados === "" || error_resultado_camp1 || error_resultado_camp2 || error_resultado_camp3 || error_resultado_camp4 || error_resultado_camp5 || error_resultado_camp6 || error_resultado_camp7 || error_resultado_camp8 || error_resultado_camp9 || error_resultado_camp10 || error_resultado_camp11 || error_n_amostras) {
            if (!obj_anexo?.data_colheita || obj_anexo?.data_colheita === "") {
                set_error_data_colheita(true)
            }
            if (!obj_anexo?.data_resultados || obj_anexo?.data_resultados === "") {
                set_error_data_resultados(true)
            }

            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {

            try {
                setIsLoading(true);

                let data = await post(auth.token.cookie_token, "new_reg_anexo_um_tres", {
                    payload: {

                        id_anexo_um_tres: 0,
                        resultado_camp1: obj_anexo?.resultado_camp1 === undefined ? '' : obj_anexo?.resultado_camp1,
                        resultado_camp2: obj_anexo?.resultado_camp2 === undefined ? '' : obj_anexo?.resultado_camp2,
                        resultado_camp3: obj_anexo?.resultado_camp3 === undefined ? '' : obj_anexo?.resultado_camp3,
                        resultado_camp4: obj_anexo?.resultado_camp4 === undefined ? '' : obj_anexo?.resultado_camp4,
                        resultado_camp5: obj_anexo?.resultado_camp5 === undefined ? '' : obj_anexo?.resultado_camp5,
                        resultado_camp6: obj_anexo?.resultado_camp6 === undefined ? '' : obj_anexo?.resultado_camp6,
                        resultado_camp7: obj_anexo?.resultado_camp7 === undefined ? '' : obj_anexo?.resultado_camp7,
                        resultado_camp8: obj_anexo?.resultado_camp8 === undefined ? '' : obj_anexo?.resultado_camp8,
                        resultado_camp9: obj_anexo?.resultado_camp9 === undefined ? '' : obj_anexo?.resultado_camp9,
                        resultado_camp10: obj_anexo?.resultado_camp10 === undefined ? '' : obj_anexo?.resultado_camp10,
                        resultado_camp11: obj_anexo?.resultado_camp11 === undefined ? '' : obj_anexo?.resultado_camp11,
                        classificacao_camp1: obj_anexo?.classificacao_camp1 === undefined ? '' : obj_anexo?.classificacao_camp1,
                        classificacao_camp2: obj_anexo?.classificacao_camp2 === undefined ? '' : obj_anexo?.classificacao_camp2,
                        classificacao_camp3: obj_anexo?.classificacao_camp3 === undefined ? '' : obj_anexo?.classificacao_camp3,
                        classificacao_camp4: obj_anexo?.classificacao_camp4 === undefined ? '' : obj_anexo?.classificacao_camp4,
                        classificacao_camp5: obj_anexo?.classificacao_camp5 === undefined ? '' : obj_anexo?.classificacao_camp5,
                        classificacao_camp6: obj_anexo?.classificacao_camp6 === undefined ? '' : obj_anexo?.classificacao_camp6,
                        classificacao_camp7: obj_anexo?.classificacao_camp7 === undefined ? '' : obj_anexo?.classificacao_camp7,
                        classificacao_camp8: obj_anexo?.classificacao_camp8 === undefined ? '' : obj_anexo?.classificacao_camp8,
                        classificacao_camp9: obj_anexo?.classificacao_camp9 === undefined ? '' : obj_anexo?.classificacao_camp9,
                        classificacao_camp10: obj_anexo?.classificacao_camp10 === undefined ? '' : obj_anexo?.classificacao_camp10,
                        classificacao_camp11: obj_anexo?.classificacao_camp11 === undefined ? '' : obj_anexo?.classificacao_camp11,
                        data_colheita: obj_anexo?.data_colheita === undefined ? '' : obj_anexo?.data_colheita,
                        data_resultados: obj_anexo?.data_resultados === undefined ? '' : obj_anexo?.data_resultados,
                        n_amostras: obj_anexo?.n_amostras === undefined ? 0 : obj_anexo?.n_amostras,
                        n_boletin: obj_anexo?.n_boletin === undefined ? '' : obj_anexo?.n_boletin,
                        id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: ""
                    }
                })
                func_print('data', data)
                if (data.status === 200) {
                    setMessage("Operação efetuada com sucesso!");
                    setOpenSnackSuccess(true);
                    set_flag_editado(false)

                    setCreateTable(false)
                    set_obj_anexo(undefined)
                    set_obj_anexo_lista((old) => [...old, data.data.result])

                } else {
                    setMessage("Erro ao efetuar a sua operação!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);

            } catch (error) {
                func_print('handle_criar_anexo', error, true)
                setIsLoading(false);

                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
        }
    }
    return (

        <CustomThemeProvider>
            <TableContainer
                component={Paper}
                variant="outlined"
                sx={{
                    height: "auto",
                    width: "auto",
                    margin: 2,
                    padding: 2,
                }}
            >
                <Snackbar
                    open={openSnackSuccess}
                    autoHideDuration={2000}
                    onClose={handleCloseSnack}
                >
                    <Alert
                        onClose={handleCloseSnack}
                        severity="success"
                        sx={{ width: "100%" }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={openSnackError}
                    autoHideDuration={2000}
                    onClose={handleCloseSnack}
                >
                    <Alert
                        onClose={handleCloseSnack}
                        severity="error"
                        sx={{ width: "100%" }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
                <table style={{ width: "100%" }}>
                    {createTable === false &&
                        <TableCell
                            colSpan={11}
                            sx={{
                                fontWeight: 600,
                                textAlign: "left",
                                fontFamily: "candara",
                                fontSize: 16,
                            }}
                        >
                            1.3 - Análise foliar
                            <BasicPopover
                                text={
                                    "Preenchimento obrigatório para os beneficiários candidatos ao regime ecológico A.3.2 - PRODI. Estes valores servirão de auxilio para o preenchimento do campo «Nutrientes disponibilizados por tipo de fertilizantes» do quadro 3 - Plano de Aplicação.\n\nOs boletins de análise devem ser apresentados sempre que forem solicitados pelos técnicos que monitorizam as intervenções no âmbito do PEPAC."
                                }
                            />
                        </TableCell>
                    }
                    {createTable === true && (
                        <TableBody>
                            <TableRow >
                                <TableCell
                                    colSpan={11}
                                    sx={{
                                        fontWeight: 600,
                                        textAlign: "left",
                                        fontFamily: "candara",
                                        fontSize: 16,
                                    }}
                                >
                                    1.3 - Análise foliar
                                    <BasicPopover
                                        text={
                                            "Preenchimento obrigatório para os beneficiários candidatos ao regime ecológico A.3.2 - PRODI. Estes valores servirão de auxilio para o preenchimento do campo «Nutrientes disponibilizados por tipo de fertilizantes» do quadro 3 - Plano de Aplicação.\n\nOs boletins de análise devem ser apresentados sempre que forem solicitados pelos técnicos que monitorizam as intervenções no âmbito do PEPAC."
                                        }
                                    />
                                </TableCell>
                                <TableCell colSpan={12}>
                                    <Stack direction="row" justifyContent="end">
                                        {is_historico === true ? <></> :

                                            <ButtonCadernos
                                                mostrarBotaoGravar
                                                aoClicarGravar={() => handle_criar_anexo()}
                                            />}
                                    </Stack>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <StyledTableHead>Elemento</StyledTableHead>
                                <StyledTableHead>
                                    N (%) <BasicPopover text="Azoto" />
                                </StyledTableHead>
                                <StyledTableHead>
                                    P (%) <BasicPopover text="Fósforo" />
                                </StyledTableHead>
                                <StyledTableHead>
                                    K (%) <BasicPopover text="Potássio" />
                                </StyledTableHead>
                                <StyledTableHead>
                                    Ca (%) <BasicPopover text="Cálcio" />
                                </StyledTableHead>
                                <StyledTableHead>
                                    Mg (%) <BasicPopover text="Magnésio" />
                                </StyledTableHead>
                                <StyledTableHead>
                                    S (%) <BasicPopover text="Enxofre" />
                                </StyledTableHead>
                                <StyledTableHead>
                                    Fe (mg/kg) <BasicPopover text="Ferro" />
                                </StyledTableHead>
                                <StyledTableHead>
                                    Mn (mg/kg) <BasicPopover text="Manganês" />
                                </StyledTableHead>
                                <StyledTableHead>
                                    Zn (mg/kg)
                                    <BasicPopover text="Zinco" />
                                </StyledTableHead>
                                <StyledTableHead>
                                    Cu (mg/kg) <BasicPopover text="Cobre" />
                                </StyledTableHead>
                                <StyledTableHead>
                                    B (mg/kg) <BasicPopover text="Boro" />
                                </StyledTableHead>
                            </TableRow>
                            <TableRow>
                                <StyledTableHead>Resultado análises</StyledTableHead>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="resultado_camp1"
                                        value={obj_anexo?.resultado_camp1 === undefined ? '' : obj_anexo?.resultado_camp1.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_resultado_camp1}
                                        helperText={error_resultado_camp1 ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="resultado_camp2"
                                        value={obj_anexo?.resultado_camp2 === undefined ? '' : obj_anexo?.resultado_camp2.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_resultado_camp2}
                                        helperText={error_resultado_camp2 ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="resultado_camp3"
                                        value={obj_anexo?.resultado_camp3 === undefined ? '' : obj_anexo?.resultado_camp3.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_resultado_camp3}
                                        helperText={error_resultado_camp3 ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="resultado_camp4"
                                        value={obj_anexo?.resultado_camp4 === undefined ? '' : obj_anexo?.resultado_camp4.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_resultado_camp4}
                                        helperText={error_resultado_camp4 ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="resultado_camp5"
                                        value={obj_anexo?.resultado_camp5 === undefined ? '' : obj_anexo?.resultado_camp5.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_resultado_camp5}
                                        helperText={error_resultado_camp5 ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="resultado_camp6"
                                        value={obj_anexo?.resultado_camp6 === undefined ? '' : obj_anexo?.resultado_camp6.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_resultado_camp6}
                                        helperText={error_resultado_camp6 ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="resultado_camp7"
                                        value={obj_anexo?.resultado_camp7 === undefined ? '' : obj_anexo?.resultado_camp7.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_resultado_camp7}
                                        helperText={error_resultado_camp7 ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="resultado_camp8"
                                        value={obj_anexo?.resultado_camp8 === undefined ? '' : obj_anexo?.resultado_camp8.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_resultado_camp8}
                                        helperText={error_resultado_camp8 ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="resultado_camp9"
                                        value={obj_anexo?.resultado_camp9 === undefined ? '' : obj_anexo?.resultado_camp9.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_resultado_camp9}
                                        helperText={error_resultado_camp9 ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="resultado_camp10"
                                        value={obj_anexo?.resultado_camp10 === undefined ? '' : obj_anexo?.resultado_camp10.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_resultado_camp10}
                                        helperText={error_resultado_camp10 ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="resultado_camp11"
                                        value={obj_anexo?.resultado_camp11 === undefined ? '' : obj_anexo?.resultado_camp11.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_resultado_camp11}
                                        helperText={error_resultado_camp11 ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledTableHead>Classificação</StyledTableHead>
                                <StyledTableCell>
                                    <CustomSelect
                                        value={obj_anexo?.classificacao_camp1 === undefined ? '' : obj_anexo?.classificacao_camp1}
                                        name="classificacao_camp1"
                                        onChange={onInputChange}
                                        options={analise_foliar_1_3_classificacao}
                                        label=""
                                    />
                                </StyledTableCell>
                                <StyledTableCell>

                                    <CustomSelect
                                        value={obj_anexo?.classificacao_camp2 === undefined ? '' : obj_anexo?.classificacao_camp2}
                                        name="classificacao_camp2"
                                        onChange={onInputChange}
                                        options={analise_foliar_1_3_classificacao}
                                        label=""
                                    />

                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomSelect
                                        value={obj_anexo?.classificacao_camp3 === undefined ? '' : obj_anexo?.classificacao_camp3}
                                        name="classificacao_camp3"
                                        onChange={onInputChange}
                                        options={analise_foliar_1_3_classificacao}
                                        label=""
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomSelect
                                        value={obj_anexo?.classificacao_camp4 === undefined ? '' : obj_anexo?.classificacao_camp4}
                                        name="classificacao_camp4"
                                        onChange={onInputChange}
                                        options={analise_foliar_1_3_classificacao}
                                        label=""
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomSelect
                                        name="classificacao_camp5"
                                        value={obj_anexo?.classificacao_camp5 === undefined ? '' : obj_anexo?.classificacao_camp5}
                                        onChange={onInputChange}
                                        options={analise_foliar_1_3_classificacao}
                                        label=""
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomSelect
                                        name="classificacao_camp6"
                                        value={obj_anexo?.classificacao_camp6 === undefined ? '' : obj_anexo?.classificacao_camp6}
                                        onChange={onInputChange}
                                        options={analise_foliar_1_3_classificacao}
                                        label=""
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomSelect
                                        name="classificacao_camp7"
                                        value={obj_anexo?.classificacao_camp7 === undefined ? '' : obj_anexo?.classificacao_camp7}
                                        onChange={onInputChange}
                                        options={analise_foliar_1_3_classificacao}
                                        label=""
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomSelect
                                        name="classificacao_camp8"
                                        value={obj_anexo?.classificacao_camp8 === undefined ? '' : obj_anexo?.classificacao_camp8}
                                        onChange={onInputChange}
                                        options={analise_foliar_1_3_classificacao}
                                        label=""
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomSelect
                                        name="classificacao_camp9"
                                        value={obj_anexo?.classificacao_camp9 === undefined ? '' : obj_anexo?.classificacao_camp9}
                                        onChange={onInputChange}
                                        options={analise_foliar_1_3_classificacao}
                                        label=""
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomSelect
                                        name="classificacao_camp10"
                                        value={obj_anexo?.classificacao_camp10 === undefined ? '' : obj_anexo?.classificacao_camp10}
                                        onChange={onInputChange}
                                        options={analise_foliar_1_3_classificacao}
                                        label=""
                                    />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <CustomSelect
                                        name="classificacao_camp11"
                                        value={obj_anexo?.classificacao_camp11 === undefined ? '' : obj_anexo?.classificacao_camp11}
                                        onChange={onInputChange}
                                        options={analise_foliar_1_3_classificacao}
                                        label=""
                                    />
                                </StyledTableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    colSpan={4}
                                    sx={{
                                        fontWeight: 600,
                                        fontFamily: "candara",
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        sx={{ justifyContent: "center", alignItems: "center" }}
                                    >
                                        Data da colheita da água:
                                        <TextField
                                            variant="filled"
                                            name="data_colheita"
                                            error={error_data_colheita}
                                            helperText={error_data_colheita === true ? 'Data obrigatória' : ''}

                                            type="date"

                                            value={obj_anexo?.data_colheita === undefined ? '' : obj_anexo?.data_colheita}

                                            onChange={onInputChange}
                                        />
                                    </Stack>
                                </TableCell>
                                <TableCell
                                    colSpan={3}
                                    sx={{
                                        fontWeight: 600,
                                        fontFamily: "candara",
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        sx={{ justifyContent: "center", alignItems: "center" }}
                                    >
                                        Data emissão resultados:
                                        <TextField
                                            variant="filled"
                                            name="data_resultados"
                                            error={error_data_resultados}
                                            helperText={error_data_resultados === true ? 'Data obrigatória' : ''}

                                            type="date"

                                            value={obj_anexo?.data_resultados === undefined ? '' : obj_anexo?.data_resultados}

                                            onChange={onInputChange}
                                        />
                                    </Stack>
                                </TableCell>
                                <TableCell
                                    colSpan={3}
                                    sx={{
                                        fontWeight: 600,
                                        fontFamily: "candara",
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        sx={{ justifyContent: "center", alignItems: "center" }}
                                    >
                                        Nº de amostras:
                                        <CustomTextField
                                            name="n_amostras"
                                            value={obj_anexo?.n_amostras === undefined ? '' : obj_anexo?.n_amostras}
                                            onChange={onInputChange}
                                            error={error_n_amostras}
                                            helperText={error_n_amostras ? 'Apenas números são aceites' : ""}
                                        />
                                    </Stack>
                                </TableCell>
                                <TableCell
                                    colSpan={3}
                                    sx={{
                                        fontWeight: 600,
                                        fontFamily: "candara",
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        sx={{ justifyContent: "center", alignItems: "center" }}
                                    >
                                        Nº do Boletim:
                                        <CustomTextField
                                            name="n_boletin"
                                            value={obj_anexo?.n_boletin === undefined ? '' : obj_anexo?.n_boletin}
                                            onChange={onInputChange}
                                        />
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    )}

                    {obj_anexo_lista.length === 0 ? <></> :
                        obj_anexo_lista.map((row, key) => {
                            if (row.id_anexo_um_tres === obj_anexo?.id_anexo_um_tres) {
                                return (
                                    <TableBody key={key}>
                                        <TableRow >
                                            <TableCell
                                                colSpan={11}
                                                sx={{
                                                    fontWeight: 600,
                                                    textAlign: "left",
                                                    fontFamily: "candara",
                                                    fontSize: 16,
                                                }}
                                            >
                                                1.3 - Análise foliar
                                                <BasicPopover
                                                    text={
                                                        "Preenchimento obrigatório para os beneficiários candidatos ao regime ecológico A.3.2 - PRODI. Estes valores servirão de auxilio para o preenchimento do campo «Nutrientes disponibilizados por tipo de fertilizantes» do quadro 3 - Plano de Aplicação.\n\nOs boletins de análise devem ser apresentados sempre que forem solicitados pelos técnicos que monitorizam as intervenções no âmbito do PEPAC."
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell colSpan={12}>
                                                <Stack direction="row" justifyContent="end">
                                                    <ButtonCadernos
                                                        mostrarBotaoGravar
                                                        aoClicarGravar={() => handle_update_anexo()}
                                                        mostrarBotaoCancelar
                                                        aoClicarCancelar={() => {
                                                            if (flag_editado) {
                                                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                            } else {
                                                                set_obj_anexo(undefined)
                                                            }
                                                        }}
                                                    />
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead>Elemento</StyledTableHead>
                                            <StyledTableHead>
                                                N (%) <BasicPopover text="Azoto" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                P (%) <BasicPopover text="Fósforo" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                K (%) <BasicPopover text="Potássio" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Ca (%) <BasicPopover text="Cálcio" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Mg (%) <BasicPopover text="Magnésio" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                S (%) <BasicPopover text="Enxofre" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Fe (mg/kg) <BasicPopover text="Ferro" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Mn (mg/kg) <BasicPopover text="Manganês" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Zn (mg/kg)
                                                <BasicPopover text="Zinco" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Cu (mg/kg) <BasicPopover text="Cobre" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                B (mg/kg) <BasicPopover text="Boro" />
                                            </StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead>
                                                Resultado análises
                                            </StyledTableHead>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="resultado_camp1"
                                                    value={obj_anexo?.resultado_camp1 === undefined ? '' : obj_anexo?.resultado_camp1.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_resultado_camp1}
                                                    helperText={error_resultado_camp1 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="resultado_camp2"
                                                    value={obj_anexo?.resultado_camp2 === undefined ? '' : obj_anexo?.resultado_camp2.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_resultado_camp2}
                                                    helperText={error_resultado_camp2 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="resultado_camp3"
                                                    value={obj_anexo?.resultado_camp3 === undefined ? '' : obj_anexo?.resultado_camp3.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_resultado_camp3}
                                                    helperText={error_resultado_camp3 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="resultado_camp4"
                                                    value={obj_anexo?.resultado_camp4 === undefined ? '' : obj_anexo?.resultado_camp4.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_resultado_camp4}
                                                    helperText={error_resultado_camp4 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="resultado_camp5"
                                                    value={obj_anexo?.resultado_camp5 === undefined ? '' : obj_anexo?.resultado_camp5.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_resultado_camp5}
                                                    helperText={error_resultado_camp5 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="resultado_camp6"
                                                    value={obj_anexo?.resultado_camp6 === undefined ? '' : obj_anexo?.resultado_camp6.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_resultado_camp6}
                                                    helperText={error_resultado_camp6 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="resultado_camp7"
                                                    value={obj_anexo?.resultado_camp7 === undefined ? '' : obj_anexo?.resultado_camp7.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_resultado_camp7}
                                                    helperText={error_resultado_camp7 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="resultado_camp8"
                                                    value={obj_anexo?.resultado_camp8 === undefined ? '' : obj_anexo?.resultado_camp8.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_resultado_camp8}
                                                    helperText={error_resultado_camp8 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="resultado_camp9"
                                                    value={obj_anexo?.resultado_camp9 === undefined ? '' : obj_anexo?.resultado_camp9.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_resultado_camp9}
                                                    helperText={error_resultado_camp9 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="resultado_camp10"
                                                    value={obj_anexo?.resultado_camp10 === undefined ? '' : obj_anexo?.resultado_camp10.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_resultado_camp10}
                                                    helperText={error_resultado_camp10 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="resultado_camp11"
                                                    value={obj_anexo?.resultado_camp11 === undefined ? '' : obj_anexo?.resultado_camp11.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_resultado_camp11}
                                                    helperText={error_resultado_camp11 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead>Classificação</StyledTableHead>
                                            <StyledTableCell>
                                                <CustomSelect
                                                    value={obj_anexo?.classificacao_camp1 === undefined ? '' : obj_anexo?.classificacao_camp1}
                                                    name="classificacao_camp1"
                                                    onChange={onInputChange}
                                                    options={analise_foliar_1_3_classificacao}
                                                    label=""
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>

                                                <CustomSelect
                                                    value={obj_anexo?.classificacao_camp2 === undefined ? '' : obj_anexo?.classificacao_camp2}
                                                    name="classificacao_camp2"
                                                    onChange={onInputChange}
                                                    options={analise_foliar_1_3_classificacao}
                                                    label=""
                                                />

                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomSelect
                                                    value={obj_anexo?.classificacao_camp3 === undefined ? '' : obj_anexo?.classificacao_camp3}
                                                    name="classificacao_camp3"
                                                    onChange={onInputChange}
                                                    options={analise_foliar_1_3_classificacao}
                                                    label=""
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomSelect
                                                    value={obj_anexo?.classificacao_camp4 === undefined ? '' : obj_anexo?.classificacao_camp4}
                                                    name="classificacao_camp4"
                                                    onChange={onInputChange}
                                                    options={analise_foliar_1_3_classificacao}
                                                    label=""
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomSelect
                                                    name="classificacao_camp5"
                                                    value={obj_anexo?.classificacao_camp5 === undefined ? '' : obj_anexo?.classificacao_camp5}
                                                    onChange={onInputChange}
                                                    options={analise_foliar_1_3_classificacao}
                                                    label=""
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomSelect
                                                    name="classificacao_camp6"
                                                    value={obj_anexo?.classificacao_camp6 === undefined ? '' : obj_anexo?.classificacao_camp6}
                                                    onChange={onInputChange}
                                                    options={analise_foliar_1_3_classificacao}
                                                    label=""
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomSelect
                                                    name="classificacao_camp7"
                                                    value={obj_anexo?.classificacao_camp7 === undefined ? '' : obj_anexo?.classificacao_camp7}
                                                    onChange={onInputChange}
                                                    options={analise_foliar_1_3_classificacao}
                                                    label=""
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomSelect
                                                    name="classificacao_camp8"
                                                    value={obj_anexo?.classificacao_camp8 === undefined ? '' : obj_anexo?.classificacao_camp8}
                                                    onChange={onInputChange}
                                                    options={analise_foliar_1_3_classificacao}
                                                    label=""
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomSelect
                                                    name="classificacao_camp9"
                                                    value={obj_anexo?.classificacao_camp9 === undefined ? '' : obj_anexo?.classificacao_camp9}
                                                    onChange={onInputChange}
                                                    options={analise_foliar_1_3_classificacao}
                                                    label=""
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomSelect
                                                    name="classificacao_camp10"
                                                    value={obj_anexo?.classificacao_camp10 === undefined ? '' : obj_anexo?.classificacao_camp10}
                                                    onChange={onInputChange}
                                                    options={analise_foliar_1_3_classificacao}
                                                    label=""
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomSelect
                                                    name="classificacao_camp11"
                                                    value={obj_anexo?.classificacao_camp11 === undefined ? '' : obj_anexo?.classificacao_camp11}
                                                    onChange={onInputChange}
                                                    options={analise_foliar_1_3_classificacao}
                                                    label=""
                                                />
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell
                                                colSpan={4}
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "candara",
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    sx={{
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    Data da colheita da água:
                                                    <TextField
                                                        variant="filled"
                                                        name="data_colheita"
                                                        error={error_data_colheita}
                                                        helperText={error_data_colheita === true ? 'Data obrigatória' : ''}

                                                        type="date"

                                                        value={obj_anexo?.data_colheita === undefined ? '' : obj_anexo?.data_colheita}
                                                        onChange={onInputChange}
                                                    />
                                                </Stack>
                                            </TableCell>
                                            <TableCell
                                                colSpan={3}
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "candara",
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    sx={{
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    Data emissão resultados:
                                                    <TextField
                                                        variant="filled"

                                                        error={error_data_resultados}
                                                        helperText={error_data_resultados === true ? 'Data obrigatória' : ''}

                                                        type="date"

                                                        value={row.data_resultados}
                                                        onChange={onInputChange}
                                                    />
                                                </Stack>
                                            </TableCell>
                                            <TableCell
                                                colSpan={3}
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "candara",
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    sx={{
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    Nº de amostras:
                                                    <CustomTextField
                                                        name="n_amostras"
                                                        value={obj_anexo?.n_amostras === undefined ? '' : obj_anexo?.n_amostras}
                                                        onChange={onInputChange}
                                                        error={error_n_amostras}
                                                        helperText={error_n_amostras ? 'Apenas números são aceites' : ""}
                                                    />
                                                </Stack>
                                            </TableCell>
                                            <TableCell
                                                colSpan={3}
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "candara",
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    sx={{
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    Nº do Boletim:
                                                    <CustomTextField
                                                        name="n_boletin"
                                                        value={obj_anexo?.n_boletin === undefined ? '' : obj_anexo?.n_boletin}
                                                        onChange={onInputChange}
                                                    />
                                                </Stack>
                                            </TableCell>
                                        </TableRow>

                                    </TableBody>
                                );

                            } else {
                                return (
                                    <TableBody key={key}>
                                        <TableRow >
                                            <TableCell
                                                colSpan={11}
                                                sx={{
                                                    fontWeight: 600,
                                                    textAlign: "left",
                                                    fontFamily: "candara",
                                                    fontSize: 16,
                                                }}
                                            >
                                                1.3 - Análise foliar
                                                <BasicPopover
                                                    text={
                                                        "Preenchimento obrigatório para os beneficiários candidatos ao regime ecológico A.3.2 - PRODI. Estes valores servirão de auxilio para o preenchimento do campo «Nutrientes disponibilizados por tipo de fertilizantes» do quadro 3 - Plano de Aplicação.\n\nOs boletins de análise devem ser apresentados sempre que forem solicitados pelos técnicos que monitorizam as intervenções no âmbito do PEPAC."
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell colSpan={12}>
                                                <Stack direction="row" justifyContent="end">
                                                    {is_historico === true ? <></> :

                                                        <ButtonCadernos
                                                            mostrarBotaoEditar
                                                            aoClicarEditar={() => {
                                                                set_obj_anexo(row)
                                                                set_error_data_colheita(false)
                                                                set_error_data_resultados(false)
                                                            }}
                                                            mostrarBotaoApagar
                                                            aoClicarApagar={() => {
                                                                set_obj_anexo(row)
                                                                set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                                            }}
                                                        />}
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead>Elemento</StyledTableHead>
                                            <StyledTableHead>
                                                N (%) <BasicPopover text="Azoto" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                P (%) <BasicPopover text="Fósforo" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                K (%) <BasicPopover text="Potássio" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Ca (%) <BasicPopover text="Cálcio" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Mg (%) <BasicPopover text="Magnésio" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                S (%) <BasicPopover text="Enxofre" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Fe (mg/kg) <BasicPopover text="Ferro" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Mn (mg/kg) <BasicPopover text="Manganês" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Zn (mg/kg)
                                                <BasicPopover text="Zinco" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                Cu (mg/kg) <BasicPopover text="Cobre" />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                B (mg/kg) <BasicPopover text="Boro" />
                                            </StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead>
                                                Resultado análises
                                            </StyledTableHead>
                                            <StyledTableCell>
                                                {row.resultado_camp1.toString().replace('.', ',')}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.resultado_camp2.toString().replace('.', ',')}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.resultado_camp3.toString().replace('.', ',')}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.resultado_camp4.toString().replace('.', ',')}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.resultado_camp5.toString().replace('.', ',')}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.resultado_camp6.toString().replace('.', ',')}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.resultado_camp7.toString().replace('.', ',')}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.resultado_camp8.toString().replace('.', ',')}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.resultado_camp9.toString().replace('.', ',')}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.resultado_camp10.toString().replace('.', ',')}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.resultado_camp11.toString().replace('.', ',')}
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead>Classificação</StyledTableHead>
                                            <StyledTableCell>
                                                {row.classificacao_camp1}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.classificacao_camp2}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.classificacao_camp3}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.classificacao_camp4}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.classificacao_camp5}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.classificacao_camp6}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.classificacao_camp7}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.classificacao_camp8}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.classificacao_camp9}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.classificacao_camp10}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.classificacao_camp11}
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell
                                                colSpan={2}
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "candara",
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    sx={{
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    Data da colheita da água:

                                                </Stack>
                                            </TableCell>
                                            <TableCell
                                                colSpan={2}

                                            >
                                                {row.data_colheita}
                                            </TableCell>
                                            <TableCell
                                                colSpan={2}
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "candara",
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    sx={{
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    Data emissão resultados:

                                                </Stack>
                                            </TableCell>
                                            <TableCell colSpan={2}>
                                                {row.data_resultados}
                                            </TableCell>
                                            <TableCell
                                                colSpan={2}
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "candara",
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    sx={{
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    Nº de amostras:
                                                    <TableCell colSpan={2}>
                                                        {row.n_amostras}
                                                    </TableCell>
                                                </Stack>
                                            </TableCell>
                                            <TableCell
                                                colSpan={2}
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "candara",
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    sx={{
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    Nº do Boletim:
                                                    <TableCell colSpan={2}>
                                                        {row.n_boletin}
                                                    </TableCell>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                )
                            }
                        })}
                </table>
                <ConfirmDialog
                    open={open_dialog_tem_a_certeza_que_quer_eliminar}
                    onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                    onConfirm={handle_delete_anexo}
                    message="Deseja eliminar o registo?"
                />
                <ConfirmDialog
                    open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                    onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                    onConfirm={() => handleCloseDialog()}
                    message={mensagem_tem_a_certeza_de_apagar_alteracoes}
                />
            </TableContainer>
        </CustomThemeProvider>

    );
};